import React from 'react';
import ImageCarousel from './ImageCarousel';
import SocialShare from './SocialShare';
import LazyImage from './LazyImage';

const MusicSection: React.FC = () => {
  const carouselImages = [
    {
      src: "https://ik.imagekit.io/bckqiai0e/DJ%20LANDAN%20TIME%20LAYDOWN.jpg?updatedAt=1747726203837",
      alt: "DJ LANDAN TIME LAYDOWN"
    },
    {
      src: "https://ik.imagekit.io/bckqiai0e/release%20me.jpg?updatedAt=1747726227725",
      alt: "Release Me"
    },
    {
      src: "https://ik.imagekit.io/bckqiai0e/DJ%20Landan%20Time-UGMH%203000.jpg?updatedAt=1747726251526",
      alt: "DJ Landan Time UGMH"
    },
    {
      src: "https://ik.imagekit.io/bckqiai0e/DJ%20Landan%20Time%20-%20Tell%20Me%20Artwork%203000.jpg?updatedAt=1747726268713",
      alt: "DJ Landan Time - Tell Me Artwork"
    }
  ];

  return (
    <section id="music" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('/artwork/background-waves-2.png')] bg-cover bg-center opacity-30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-950/10 to-black"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white mb-16 text-center">Music</h2>

        <div className="mb-12 max-w-4xl mx-auto">
          <iframe
            loading="lazy"
            src="https://pro.music-worx.com/embed/tell-me-clubsoul-remix-promo?social=1"
            width="100%"
            height="320"
            className="rounded-xl"
            title="Tell Me ClubSoul Remix"
          />
        </div>

        <div className="bg-gray-900/30 rounded-2xl p-8 border border-purple-900/30">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">Featured Music</h3>
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-800/50 rounded-xl p-8 text-center border border-purple-900/50">
              <div className="mb-6">
                <svg className="w-20 h-20 mx-auto text-orange-500 mb-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M7 17.939h-1v-8.068c.308-.231.639-.429 1-.566v8.634zm3 0h1v-9.224c-.229.265-.443.548-.621.857l-.379-.184v8.551zm-2 0h1v-8.848c-.508-.079-.623-.05-1-.01v8.858zm-4 0h1v-7.02c-.312.458-.555.971-.692 1.535l-.308-.182v5.667zm-3-5.25c-.606.547-1 1.354-1 2.268 0 .914.394 1.721 1 2.268v-4.536zm18.879-.671c-.204-2.837-2.404-5.079-5.117-5.018-1.022-1.377-2.64-2.268-4.484-2.268-3.033 0-5.491 2.458-5.491 5.491 0 .126.011.251.019.377-.465.304-.904.664-1.298 1.076.227-.467.507-.897.836-1.279-.01-.058-.012-.117-.012-.176 0-3.584 2.916-6.5 6.5-6.5 2.913 0 5.377 1.92 6.182 4.561 2.195.43 3.818 2.383 3.818 4.707 0 .596-.11 1.166-.308 1.691v-2.662zm-6.879 5.921h1v-9.869c-.314.018-.62.074-.916.164l-.084-.058v9.763zm2 0h1v-9.597c-.309-.107-.632-.178-.969-.2l-.031-.07v9.867zm2 0h1v-8.465c-.354-.231-.741-.414-1.158-.528v8.993z"/>
                </svg>
                <h4 className="text-xl font-semibold text-white mb-2">Listen on SoundCloud</h4>
                <p className="text-gray-400 mb-6">Check out my latest tracks, remixes, and DJ sets</p>
              </div>
              <a
                href="https://soundcloud.com/djlandantime"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-orange-500/50"
              >
                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M7 17.939h-1v-8.068c.308-.231.639-.429 1-.566v8.634zm3 0h1v-9.224c-.229.265-.443.548-.621.857l-.379-.184v8.551zm-2 0h1v-8.848c-.508-.079-.623-.05-1-.01v8.858zm-4 0h1v-7.02c-.312.458-.555.971-.692 1.535l-.308-.182v5.667zm-3-5.25c-.606.547-1 1.354-1 2.268 0 .914.394 1.721 1 2.268v-4.536zm18.879-.671c-.204-2.837-2.404-5.079-5.117-5.018-1.022-1.377-2.64-2.268-4.484-2.268-3.033 0-5.491 2.458-5.491 5.491 0 .126.011.251.019.377-.465.304-.904.664-1.298 1.076.227-.467.507-.897.836-1.279-.01-.058-.012-.117-.012-.176 0-3.584 2.916-6.5 6.5-6.5 2.913 0 5.377 1.92 6.182 4.561 2.195.43 3.818 2.383 3.818 4.707 0 .596-.11 1.166-.308 1.691v-2.662zm-6.879 5.921h1v-9.869c-.314.018-.62.074-.916.164l-.084-.058v9.763zm2 0h1v-9.597c-.309-.107-.632-.178-.969-.2l-.031-.07v9.867zm2 0h1v-8.465c-.354-.231-.741-.414-1.158-.528v8.993z"/>
                </svg>
                Visit My SoundCloud
              </a>
            </div>
          </div>
          <div className="mt-6 flex justify-center">
            <SocialShare
              url="https://soundcloud.com/djlandantime"
              title="DJ Landan Time on SoundCloud"
              description="Check out DJ Landan Time's tracks on SoundCloud."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MusicSection;